<template>
  <div class="uc-index">
    个人中心页
    <el-button type="primary" class="signinButton" :disabled="!canSubmit" @click="signin()">注销</el-button>
    <el-button type="primary" class="signinButton" @click="gainDetectAuth()">人脸核身</el-button>
  </div>
</template>
<script>
// import { mapGetters } from 'vuex'
import { accountLogOff, getDetectAuth } from '@/api/modules/iam'
export default {
  name: 'UCHome',
  components: {
  },
  data() {
    return {
    }
  },
  computed: {
    // ...mapGetters({
    //   userInfo: 'userAuth/getUsersCurrentInfo'
    // }),
    // showPage() {
    //   return !!this.userInfo || this.$route.meta.noAuth
    // }
  },
  mounted() {
  },
  created() {
  },
  methods: {
    async signin() {
      const res = await accountLogOff({ 'id': this.userInfo.id })
      if (res.code === 0) {
        this.$message({
          message: '注销成功！即将跳转至首页！',
          type: 'success'
        })
        // 登陆成功 获取user信息 保存本地 并且跳转回首页
        setTimeout(() => {
          this.$router.replace('/login')
        }, 1000)
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    async gainDetectAuth() {
      const res = await getDetectAuth()
      if (res.code === 0) {
        console.log(res.data)
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    }
  }
}
</script>

<style lang='less' scope>
</style>
